import { createApiBuilderFromCtpClient } from "@commercetools/platform-sdk"
import { ClientBuilder } from "@commercetools/sdk-client-v2"

import { AppSettings } from "@/settings"

export const runtime = "nodejs"

class _CommerceService {
  #config = {}

  /** @type {import('@commercetools/sdk-client-v2').ClientBuilder} */
  #client = null

  constructor() {
    this.#config = AppSettings.ctpConfig()

    const { projectKey, clientSecret, clientID, authUrl, apiUrl, scopes } = this.#config

    const authMiddlewareOptions = {
      host: authUrl,
      projectKey,
      credentials: {
        clientId: clientID,
        clientSecret: clientSecret,
      },
      scopes,
    }

    const httpMiddlewareOptions = {
      host: apiUrl,
    }

    this.#client = new ClientBuilder()
      .withProjectKey(projectKey)
      .withClientCredentialsFlow(authMiddlewareOptions)
      .withHttpMiddleware(httpMiddlewareOptions)
      // .withLoggerMiddleware()
      .build()
  }

  api() {
    const { projectKey } = this.#config

    return createApiBuilderFromCtpClient(this.#client).withProjectKey({
      projectKey,
    })
  }

  client() {
    return this.#client
  }

  config() {
    return this.#config
  }
}

export const CommerceService = new _CommerceService()
